import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import MainHeader from '../../../headers/MainHeader/MainHeader';
import * as actions from '../../../../redux/projects/actions.projects';
import * as projectAnalyticsActions from '../../../../redux/projectAnalytics/actions.projectAnalytics';
import * as scriptEditorActions from '../../../../redux/scriptEditor/actions.scriptEditor';
import projectHelper from '../../../../services/ProjectHelper';
import ScreenshotLogOverlay from '../../../components/ScreenshotLogOverlay/ScreenshotLogOverlay';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import getProjectId from '../../../../services/mini/getProjectId';
import HistoryKeeper from '../../../../services/HistoryKeeper';
import { AnalyticColumn } from '../AnalyticsColumn/AnalyticsColumn';
import { Loader } from '../../../components/Loader/Loader';
import AnalyticsHeader from '../AnalyticsHeader';

class AnalyticsPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        const { projectId } = this.props;

        const environment = projectHelper.getEnvironment(projectId);

        this.state = {
            filtersExpanded: false,
            refreshTs: null,
            environment: environment,
        };
    }

    componentDidMount() {
        const { getProject, projectId } = this.props;
        const { environment } = this.state;
        HistoryKeeper.push();
        getProject({ projectId, environment }).then(() => {
            this.requestViewData();
        });
    }

    requestViewData() {
        const { project, getAnalyticsReports } = this.props;
        const { environment } = this.state;

        getAnalyticsReports({ project, environment });
    }

    changeEnvironment = async ({ project, environment }) => {
        const {
            rememberProjectEnvironment,
            resetAnalyticsReportsData,
        } = this.props;

        await resetAnalyticsReportsData({ projectId: project.projectId });

        this.setState({
            environment,
        }, () => {
            this.requestViewData();
        });
        rememberProjectEnvironment({
            environment,
            projectId: project.projectId,
        });
    }

    refreshAlanyticsData = async () => {
        const { resetAnalyticsReportsData, projectId } = this.props;

        await resetAnalyticsReportsData({ projectId });

        this.setState({
            refreshTs: Date.now()
        }, () => {
            this.requestViewData();
        });
    }

    toggleFilters = () => {
        this.setState({
            filtersExpanded: !this.state.filtersExpanded
        });
    }

    addReport = () => {
        const { addAnalyticsReport, project } = this.props;
        const { environment } = this.state;

        addAnalyticsReport({
            project,
            environment,
        });
    }

    render() {
        const {
            project,
            projectId,
            projectName,
            audioFromLog,
            reports,
            settings,
            blockingActionInProcess,
            features
        } = this.props;

        const {
            environment,
            filtersExpanded,
            refreshTs
        } = this.state;

        return (
            <div className="analytics-page">
                <MainHeader
                    environment={environment}>
                    <AnalyticsHeader
                        projectName={projectName}
                        environment={environment}
                        refreshAlanyticsData={this.refreshAlanyticsData}
                        changeEnvironment={this.changeEnvironment} />
                </MainHeader>
                <div className={`analytics-page__body ${blockingActionInProcess && 'disabled'} ${environment}`}>
                    {_.isArray(reports) ?
                        <React.Fragment>
                            {reports.map((report, index) => {
                                return <AnalyticColumn
                                    key={report.name}
                                    index={index}
                                    report={report}
                                    reports={reports}
                                    settings={settings}
                                    projectId={projectId}
                                    environment={environment}
                                    project={project}
                                    features={features}
                                    audioFromLog={audioFromLog}
                                    refreshTs={refreshTs}
                                    filtersExpanded={filtersExpanded}
                                    toggleFilters={this.toggleFilters}
                                />;
                            })}
                            <div
                                className="analytics-page__add-report-btn"
                                title="Add stats to compare"
                                onClick={this.addReport}>
                                <i className="icon icon-alan-add-circle" />
                            </div>
                        </React.Fragment> :
                        <Loader theme="dark" size="big" center={true} />}
                </div>
                <ScreenshotLogOverlay />
            </div>
        );
    }
}

function mapStateToProps({ projectsInfo, projectAnalytics, config }, ownProps) {
    const projectName = ownProps.params.projectName;
    const projects = projectsInfo.projects;
    const projectId = getProjectId(projectName, projects);
    const project = projectsInfo.currentProject;

    return {
        projectName,
        projectId,
        project,
        reports: projectAnalytics.projectsAnalytics[projectId]?.reports,
        settings: projectAnalytics.projectsAnalytics[projectId]?.settings,
        blockingActionInProcess: projectAnalytics.projectsAnalytics[projectId]?.blockingActionInProcess,
        hasProjectsData: projectsInfo.hasProjectsData,
        audioFromLog: projectsInfo.currentProject.audioFromLog,
        features: config?.features
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getAnalyticsReports: (param) => asyncDispatch(projectAnalyticsActions.getAnalyticsReports, dispatch, param),
        addAnalyticsReport: (param) => asyncDispatch(projectAnalyticsActions.addAnalyticsReport, dispatch, param),
        resetAnalyticsReportsData: (param) => asyncDispatch(projectAnalyticsActions.resetAnalyticsReportsData, dispatch, param),
        rememberProjectEnvironment: (param) => dispatch(actions.rememberProjectEnvironment(param)),
        getLogImage: (param) => asyncDispatch(actions.getLogImage, dispatch, param),
        highlightLine: (param) => dispatch(scriptEditorActions.highlightLine(param)),
        getProject: (param) => asyncDispatch(actions.getProject, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsPage);
